import DateFormatterUtils from '../utils/date-formatter-utils';

function isToday(date1, date2) {
  return date1.toLocaleDateString() === date2.toLocaleDateString();
}

function diffMinutes(date1, date2) {
  return Math.floor((date2 - date1) / (60 * 1000));
}

function isSameHour(date1, date2) {
  return diffMinutes(date1, date2) < 60;
}

function diffHours(date1, date2) {
  return date2.getHours() - date1.getHours();
}

function isSameMinutes(date1, date2) {
  return date2.getMinutes() === date1.getMinutes();
}

export default function (value) {
  if (!value) return null;

  const dateNow = new Date();

  let timeText = '';

  const dateValue = new Date(value);

  if (isToday(dateValue, dateNow)) {
    if (!isSameHour(dateValue, dateNow)) {
      const hours = diffHours(dateValue, dateNow);

      timeText = `há ${hours} hora`;

      if (hours > 1) {
        timeText += 's';
      }

      return timeText;
    }

    if (!isSameMinutes(dateValue, dateNow)) {
      const minutes = diffMinutes(dateValue, dateNow);

      if (minutes > 0) {
        timeText = `há ${minutes} minuto`;

        if (minutes > 1) {
          timeText += 's';
        }

        return timeText;
      }
    }

    return 'agora há pouco';
  }
  return DateFormatterUtils.formatDateTime(value, true);
}
